import { useEffect, useState, Suspense } from 'react'
import { BrowserRouter, Navigate } from 'react-router-dom'
import { Box } from '@chakra-ui/react'
import UserService from './services/user-service'
import { Topbar } from './components/Topbar'
import { Sidebar } from './components/Sidebar'
import { SplashGuard } from './guard/SplashGuard'
import LocaleContextProvider from './locales/LocaleContext'
import { RtlProvider } from './RtlProvider'
import AppRoutes from './AppRoute/AppRoutes'
import Assistant from './components/Assistant'
import RedButton from './components/RedButton'
import LiteModal from './components/LiteModal'
// import { DeepLink } from './utils/flutter'

import 'react-phone-input-2/lib/style.css'
import './locales/i18n'

function App() {
	const [userInfo, setUserInfo] = useState<any>({})
	const [userRoles, setUserRoles] = useState<any>(null)
	const [isSidebarOpen, setIsSidebarOpen] = useState(false)
	const [isNewsletterOnly, setIsNewsletterOnly] = useState<boolean>(true)
	const [isAuthenticated, setIsAuthenticated] = useState(false)

	useEffect(() => {
		// Check if the user is authenticated
		UserService.info().then((authStatus: boolean) => {
			setIsAuthenticated(true)
			if (!authStatus) {
				;<Navigate to='/' />
			}
		})
	}, [Navigate])

	return (
		<Suspense fallback={<div />}>
			<div
				style={{
					position: 'absolute',
					top: 0,
					left: 0,
					width: '100%',
					height: '100%',
				}}
				className=''
			></div>
			<LocaleContextProvider>
				<RtlProvider>
					<Box
						bg={'#fafafa'}
						height='max-content'
					>
						<BrowserRouter>
							<SplashGuard>
								<Topbar
									userInfo={userInfo}
									userRoles={userRoles}
									setUserInfo={setUserInfo}
									setUserRoles={setUserRoles}
									setIsSidebarOpen={setIsSidebarOpen}
									setIsNewsletterOnly={setIsNewsletterOnly}
								/>
								<Assistant user={userInfo} />
								{userInfo && Object.keys(userInfo).length > 0 && <RedButton />}
								{isSidebarOpen && (
									<Sidebar
										userRoles={userRoles}
										userInfo={userInfo}
										setIsSidebarOpen={setIsSidebarOpen}
										isNewsletterOnly={isNewsletterOnly}
									/>
								)}
								<AppRoutes
									isAuthenticated={isAuthenticated}
									isNewsletterOnly={isNewsletterOnly}
									userInfo={userInfo}
								/>
								<LiteModal />
								{/* <DeepLink /> */}
							</SplashGuard>
						</BrowserRouter>
					</Box>
				</RtlProvider>
			</LocaleContextProvider>
		</Suspense>
	)
}

export default App
